import React, { useEffect, useState } from "react";
import "./index.css";
import { useLoad } from "../../context/Load";
import { useLocation, useNavigate } from "react-router";
import ApiServices from "../../services/apiServices";
import voltar from "../../assets/images/png/voltar.png";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import storage from "../../services/storage";
import { validaEmail } from "../../services/validaEmail";

export default function EmailRecadastroEmail() {
  const { load, setLoad } = useLoad();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [trava, setTrava] = useState(false);
  async function fnEnviarEmail() {
    setTrava(true);
    var obj = {
      codigoLogin: storage.get("USUARIO")?.login,
      email: email,
    };
    try {
      setLoad(true);
      const response = await ApiServices.apiPost(
        "duplo-fator/deslogado/codigo/login/enviar/email",
        obj
      );
      const data = await response.json();

      if (data.statusCode === 200) {
        const atualizado = Object.assign(storage?.get("USUARIO") || {}, {
          email: email,
        });
        storage.set("USUARIO", atualizado);
        navigate("/email-recadastro-verificacao");
      } else {
        toast.error(data.message);
      }
      setTrava(false);
    } catch (err) {
      setTrava(false);
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  function ocultarEmail(email) {
    const parts = email?.split("@");
    const prefix = parts[0];
    const obscuredPrefix =
      prefix?.substring(0, 2) + "*".repeat(prefix.length - 2);
    return obscuredPrefix + "@" + parts[1];
  }

  return (
    <>
      <div className="imgBackground"></div>{" "}
      <div className="d-flex justify-content-center">
        <div style={{ maxWidth: 500 }}>
          <div className="px-5">
            <Link to={"/email-recadastro-login"}>
              <img className="imgVoltar" src={voltar} alt="" />
            </Link>
            <div className="emailRecadastroEmailTexto1">Legal!</div>
            <div className="emailRecadastroEmailTexto2">
              <div style={{ marginBottom: 10 }}>
                Precisamos agora que cadastre o seu melhor e-mail.
              </div>
            </div>
            <label
              htmlFor="labelEmailRecadastroEmail"
              className="labelEmailRecadastroEmail"
            >
              Informe seu melhor e-mail
            </label>
            <form autoComplete="off">
              <input
                autoComplete="off"
                name="labelEmailRecadastroEmail"
                className="inputPrimary"
                type="text"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <div
                className="labelLoginCpf m-0"
                style={{ color: "#FF3E0E", fontWeight: 600 }}
              >
                {validaEmail(email)
                  ? " "
                  : email.length > 5 && "E-mail invalido"}
              </div>
            </form>
            <div className="emailRecadastroEmailTexto3">
              Vamos enviar por e-mail um código de validação
            </div>

            <button
              onClick={fnEnviarEmail}
              className="btn btn-primary w-100 "
              disabled={!validaEmail(email) || trava}
            >
              Enviar código
            </button>
            {/* <div className="emailVerificacaoTexto4">
          Se não reconhece esse e-mail, entre em contato com seu gerente para
          maiores informações.
        </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
